












import { Component, Prop, Vue } from "vue-property-decorator";
import router from "@/router";

@Component
class Header extends Vue {
  homeClick() {
    if (this.$route.path != "/") router.push("/");
  }
}

export default Header;
